export const ASSISTANT_LAUNCH_PATH = "/assistant-launch";
/** Maximum bootstrap wait before the relaunch page exposes recovery actions. */
export const ASSISTANT_LAUNCH_READINESS_TIMEOUT_MS = 5000;
export const ASSISTANT_LAUNCH_RETURN_URL_STORAGE_KEY =
  "assistantLaunchReturnUrl";

const INTERNAL_URL_BASE = "https://finn-app.invalid";

export const isAssistantLaunchReturnUrl = (value: unknown): value is string => {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//")
  ) {
    return false;
  }

  try {
    const parsedUrl = new URL(value, INTERNAL_URL_BASE);
    const bounceValues = parsedUrl.searchParams.getAll("bounce");
    let hasUnexpectedParameter = false;

    parsedUrl.searchParams.forEach((_parameterValue, parameterName) => {
      if (parameterName !== "bounce") {
        hasUnexpectedParameter = true;
      }
    });

    return (
      parsedUrl.origin === INTERNAL_URL_BASE &&
      parsedUrl.pathname === ASSISTANT_LAUNCH_PATH &&
      !hasUnexpectedParameter &&
      bounceValues.length <= 1 &&
      (bounceValues.length === 0 || /^\d+$/.test(bounceValues[0]))
    );
  } catch {
    return false;
  }
};
